import { useQuery } from '@tanstack/react-query';
import { portfolioApi } from '../services/api';
import type { PortfolioSummary, AllocationItem, PortfolioHistoryPoint } from '../types';

export function usePortfolioSummary() {
  return useQuery<PortfolioSummary>({
    queryKey: ['portfolio', 'summary'],
    queryFn: portfolioApi.getSummary,
    staleTime: 1000 * 60 * 2, // 2 minutes
  });
}

export function usePortfolioAllocation() {
  return useQuery<AllocationItem[]>({
    queryKey: ['portfolio', 'allocation'],
    queryFn: portfolioApi.getAllocation,
  });
}

export function usePortfolioPerformance() {
  return useQuery({
    queryKey: ['portfolio', 'performance'],
    queryFn: portfolioApi.getPerformance,
  });
}

export function usePortfolioValue() {
  return useQuery({
    queryKey: ['portfolio', 'value'],
    queryFn: portfolioApi.getValue,
  });
}

export function usePortfolioHistory() {
  return useQuery<PortfolioHistoryPoint[]>({
    queryKey: ['portfolio', 'history'],
    queryFn: portfolioApi.getHistory,
    staleTime: 1000 * 60 * 5,
  });
}
